import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsDistribution,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsFilters,
} from "../../../../../shared/api/types";

export const useWellnessOverviewStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || [
      "recovery_score",
      "recovery",
      "hrv",
      "average_hrv",
      "resting_heart_rate",
      "sleep_performance",
      "sleep",
      "hours_of_sleep",
      "strain",
      "workout_time",
      "total_users",
      "active_users",
      "participation_rate",
      "completion_rate",
      "total_active_employees",
      "wellness_participation_rate",
      "high_risk_employees",
      "medium_risk_employees",
      "low_risk_employees",
    ],
  });
};

export const useRecoveryStrainTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || ["recovery", "strain"],
    granularity: params?.granularity || "daily",
  });
};

export const useSleepTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || ["hours_of_sleep", "hours_of_sleep_needed"],
    granularity: params?.granularity || "daily",
  });
};

export const useHRVTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || ["hrv", "average_hrv"],
    granularity: params?.granularity || "daily",
  });
};

export const useWorkoutTimeTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || ["workout_time"],
    granularity: params?.granularity || "daily",
  });
};

export const useRecoveryScoreDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "recovery_score_distribution",
  });
};

export const useHRVDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "hrv_distribution",
  });
};

export const useSleepDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "sleep_distribution",
  });
};

export const useStrainActivityByDepartment = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "strain_activity_by_department",
  });
};

export const useSleepQualityByDepartment = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "sleep_quality_by_department",
  });
};

export const useWorkoutActivityByDepartment = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "workout_activity_by_department",
  });
};

export const useWellbeingDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "wellbeing_dimensions",
  });
};
